import { Component, OnInit, ViewChild, Inject, ElementRef, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UIService } from 'shared/services/UI/ui.service';

@Component({
  selector: 'app-email-verification-dialog',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})
export class EmailVerificationDialogComponent implements OnInit {
  invalid: Boolean = false;
  initted: Boolean = false;
  email: string;

  @ViewChild('focusOne') _el: ElementRef;
  @ViewChild('focusTwo') fTwo: ElementRef;
  @ViewChild('focusThree') fThree: ElementRef;
  @ViewChild('focusFour') fFour: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<EmailVerificationDialogComponent>,
    private ui: UIService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
    if (data.invalid === true) {
      this.invalid = true;
    }
    this.email = data.email;
  }
  profImage: string;
  one: string;
  two: string;
  three: string;
  four: string;
  code: string;

  focus(event) {
    const id = event.target.id;
    if (event.code === 'Backspace') {
      if (id === '0') {

      }
      if (id === '1') {
        this._el.nativeElement.focus();
      }
      if (id === '2') {
        this.fTwo.nativeElement.focus();
      }
      if (id === '3') {
        this.fThree.nativeElement.focus();
      }
    } else {
      if (id === '0') {
        this.fTwo.nativeElement.focus();
      }
      if (id === '1') {
        this.fThree.nativeElement.focus();
      }
      if (id === '2') {
        this.fFour.nativeElement.focus();
      }
      if (id === '3') {
        this.verify();
      }
    }
  }
  verify() {
    this.code = this.one + this.two + this.three + this.four;
    this.one = this.two = this.three = this.four = '';
    this._el.nativeElement.focus();
    this.ui.emitLoaderState(true);
    this.dialogRef.close(this.code);
    this.code = '';
  }
  logout() {
    this.dialogRef.close('LOGOUT');
  }
  resend() {
    this.dialogRef.close('RESEND');
    this.ui.emitLoaderState(true);
  }
  ngOnInit() {
    this.ui.emitChange('VERIFY EMAIL');
    this.initted = true;
    this._el.nativeElement.focus();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/User/AuthDialog/email-verification/email-verification.component.ts